import { render } from "./404.vue?vue&type=template&id=2585a9d2"
import script from "./404.vue?vue&type=script&lang=js"
export * from "./404.vue?vue&type=script&lang=js"

import exportComponent from "C:\\eikainteriors\\eikainteriors\\frontend\\eikaiinteriors\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__